export default __webpack_public_path__ + "static/media/pic84.8a3741d3.jpg";